import {
  IonButton,
  IonCheckbox,
  IonContent,
  IonHeader,
  IonItem,
  IonModal,
} from "@ionic/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface modalProps {
  showBedAssignModal: boolean;
  handleClose: Function;
  modalData: {
    patientName: string;
    assignedStatus: string;
  };
  assignPatient: Function;
}

const BedAssignPopup: React.FunctionComponent<modalProps> = (
  props: modalProps
) => {
  

  const [isPrimaryMd, setIsPrimaryMd]: [boolean, Function] = useState(false);
  const { t } = useTranslation("patients"); // namespace

  return (
    <IonModal
      isOpen={props.showBedAssignModal}
      backdropDismiss={false}
      className="assign-patient-modal"
    >
      <IonHeader className="d-flex justify-content-between">
        <div>
          {props.modalData.assignedStatus === "assigned"
    ? t("unassignPatient")
    : t("assignPatient")}
        </div>
        <span
          className="d-inline-block clickable icon-close"
          onClick={() => props.handleClose(false)}
        ></span>
      </IonHeader>
      <IonContent className="modal-content">
        <div className="modal-container">
          <p className="text-center patient-name">
            {props.modalData.patientName}
          </p>
          <span className="m-0 modal-text">
  {t("assignMessage", {
    action:
      props.modalData.assignedStatus === "assigned"
        ? t("unassigned")
        : t("assigned"),
  })}
</span>
          {props.modalData.assignedStatus === "unAssigned" && (
            <div>
              <IonItem className="primary-md-checkbox">
                <div className="d-flex">
                  <IonCheckbox
                    className="m-0"
                    checked={isPrimaryMd}
                    onIonChange={(e) => setIsPrimaryMd(e.detail.checked)}
                  />
                 <label className="ml-2">{t("markPrimaryMd")}</label>
                </div>
              </IonItem>
            </div>
          )}
          <div className="d-flex justify-content-end btn-container">
            <IonButton
              color="medium"
              className="button secondary-btn btn-curved mr-2"
              onClick={() => props.handleClose(false)}
            >
              {t("cancel")}
            </IonButton>
            <IonButton
              className="button primary-btn btn-curved"
              onClick={() => props.assignPatient(isPrimaryMd)}
            >
                {t("confirm")}

            </IonButton>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default BedAssignPopup;
